import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import ProductSettingDetailsForm from '../ProductSettingDetailsForm';

import * as Styles from './_productSettingDetails.module.scss';

const ProductSettingDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.setting.modals.productSettingDetailsModalIsOpen);
    const getSettingsError = useAppSelector(state => state.setting.errors.getSettings);
    const getSettingsIsLoading = useAppSelector(state => state.setting.loadings.getSettings);

    const handleModalOnClose = () => {
        dispatch(combinedActions.settingResetUpdateSettingsState());
        dispatch(combinedActions.settingSetProductSettingDetailsModalIsOpen(!isOpen));
        dispatch(combinedActions.settingSetProductSettingDetailsModalIsEditing(false));
    };

    return (
        <Modal
            title='Product Setting Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {getSettingsIsLoading
                ? (
                    <CustomClipLoader
                        blackBorder
                        className={Styles.loader}
                    />
                )
                : (getSettingsError
                    ? (
                        <Text
                            isError
                            label={getSettingsError}
                        />
                    )
                    : (
                        <div className={Styles.subcontainer}>
                            <ProductSettingDetailsForm />
                        </div>
                    )
                )
            }
        </Modal>
    );
};

export default ProductSettingDetailsModal;
